import { render, staticRenderFns } from "./CouchImageWrap.vue?vue&type=template&id=476f63de&scoped=true"
import script from "./CouchImageWrap.vue?vue&type=script&lang=js"
export * from "./CouchImageWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476f63de",
  null
  
)

export default component.exports